import { CircularProgress } from '@mui/joy';
import { CSSProperties } from 'react';

import { Size } from 'theme/enums';

import { Img, Wrapper } from './logoStyle';

interface IProps {
  url?: string;
  path?: string;
  isLoaded?: boolean;
  onLoad?: () => void;
  style?: CSSProperties;
}

const LogoView = ({ url, path, isLoaded, onLoad, style }: IProps) => {
  const showSpinner = !path || !isLoaded;

  return (
    <Wrapper to={url ?? '#'} style={style} hasUrl={Boolean(url)}>
      {showSpinner && <CircularProgress size={Size.SM} />}

      <Img src={path} onLoad={onLoad} isLoaded={!showSpinner} style={style} />
    </Wrapper>
  );
};

export default LogoView;
